<template>
<div class="container">
    <div class="row">
        <Button size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <div class="col-12 mt-3 pl-0 d-flex">
            <h3 class="c-ndarkthree">
                <span class="bold">Dados da empresa</span>
            <span class="c-ndarkthree"> | </span>
                {{ $store.state.register.company.name }}
            </h3>
        </div>
        <BoxRegister @saveChange="saveChanges">
            <div class="col-12 mt-4">
                <h4 class="c-ndarkfour bold">
                    Já conseguimos algumas informações com base em seu CNPJ. 
                </h4>
                <h6 class="c-ndarkthree regular">
                    Complete as informações que faltam para que possamos conhecer melhor sua empresa!
                </h6>
            </div>
            <div class="col-12 mt-4 pl-0">
                <div class="col-6">

                    <InputText label="CNPJ" v-model="cnpj" v-mask="'##.###.###/####-##'"/>
                </div>
            </div>
            <div class="col-12 d-flex align-items-center mt-5">
                <router-link to="" @click.native="dialogVisible = true"  :class="`${getPrimaryColor} mr-4`">
                    Voltar
                </router-link>
                <Button @click="nextStep" :color="getPrimaryColor"> Consultar </Button>
            </div>
        </BoxRegister>
    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @cancelRegister="backStep" @saveChange="saveChanges"/>
</div>
</template>

<script>
import CancelRegister from '@/components/modals/CancelRegister'
import BoxRegister from '@/components/box/BoxRegister'
import ArrowDropdown from '@/components/icons/ArrowDropdown'

export default {
    components: {
        CancelRegister,
        BoxRegister,
        ArrowDropdown,
    },
    data() {
        return {
            dialogVisible: false,
            cnpj: '',
            rules: {
                number: [{
                    required: true,
                    message: '',
                    trigger: 'change',
                }, ],
            },
            formValid: false,
        }
    },
    methods: {
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        nextStep() {
            this.$router.push('/partner')
        },
        backStep() {
            if (this.$route.path.includes('partner')) {
                if (this.$route.name == 'pf/documents') return this.$router.push(`/partner/${this.$route.params.idCNPJ}/pf/${this.$route.params.id}/0`)
                if (this.$route.name == 'pj/documents') return this.$router.push(`/partner/${this.$route.params.idCNPJ}/pj/${this.$route.params.id}/1`)
                return this.$router.push(`/partner/${this.$route.params.idCNPJ}/procurator/0`)
            } else {
                if (this.$route.name == 'buyer/documents') return this.$router.push(`/buyer/register/${this.$route.params.id}/2`)
                if (this.$route.name == 'sponsor/documents') return this.$router.push(`/sponsor/register/${this.$route.params.id}/2`)
                return this.$router.push(`/provider/register/${this.$route.params.id}/2`)
            }
        },
        saveChanges() {
            this.$emit('saveChange')
            this.backStep()
        }
    }

}
</script>

<style lang="scss" scoped>

</style>
